if (!customElements.get('buy-box-price')) {
  customElements.define(
    'buy-box-price',
    class BuyBoxPrice extends HTMLElement {
      constructor() {
        super();
        this.onQuantityChange = this.handleQuantityChange.bind(this);
      }

      connectedCallback() {
        this.input = document.getElementById(this.dataset.quantityInput);
        this.compareEl = this.querySelector('.buy-box__price-compare');
        this.currentEl = this.querySelector('.buy-box__price-current');
        this.unitPrice = Number(this.dataset.unitPrice) || 0;
        this.unitCompareAtPrice = Number(this.dataset.unitCompareAtPrice) || 0;
        this.moneyFormat = this.dataset.moneyFormat;

        if (this.input) this.input.addEventListener('change', this.onQuantityChange);
      }

      disconnectedCallback() {
        if (this.input) this.input.removeEventListener('change', this.onQuantityChange);
      }

      handleQuantityChange() {
        const min = parseInt(this.input.min, 10) || 1;
        const quantity = Math.max(min, parseInt(this.input.value, 10) || min);

        if (this.currentEl) {
          this.currentEl.textContent = window.formatMoney(this.unitPrice * quantity, this.moneyFormat);
        }

        if (this.compareEl && this.unitCompareAtPrice > this.unitPrice) {
          this.compareEl.textContent = window.formatMoney(this.unitCompareAtPrice * quantity, this.moneyFormat);
        }
      }
    }
  );
}
